import { render } from "./QuizForm.vue?vue&type=template&id=0ed75cfe&scoped=true"
import script from "./QuizForm.vue?vue&type=script&lang=js"
export * from "./QuizForm.vue?vue&type=script&lang=js"

import "./QuizForm.vue?vue&type=style&index=0&id=0ed75cfe&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed75cfe"]])

export default __exports__